<template>
    <div class="card order-success__meta">
        <ul class="order-success__meta-list">
            <li class="order-success__meta-item">
                <span class="order-success__meta-title">Order number:</span>
                <span class="order-success__meta-value">#{{ordered_summary.order_number}}</span>
            </li>
            <li class="order-success__meta-item">
                <span class="order-success__meta-title">Created:</span>
                <span class="order-success__meta-value">{{ordered_summary.created_date}}</span>
            </li>
            <li class="order-success__meta-item">
                <span class="order-success__meta-title">Total:</span>
                <span class="order-success__meta-value notranslate">{{toUSD(ordered_summary.grandtotal)}}</span>
            </li>
            <li class="order-success__meta-item">
                <span class="order-success__meta-title">Payment Method:</span>
                <span class="order-success__meta-value">{{ordered_summary.payment_method}}</span>
            </li>
        </ul>
    </div>
    <div class="card">
        <div class="order-list">
            <table>
                <thead class="order-list__header">
                    <tr>
                        <th class="order-list__column-label" colspan="2">Product</th>
                        <th class="order-list__column-quantity">Quantity</th>
                        <th class="order-list__column-total">Total</th>
                    </tr>
                </thead>
                <tbody class="order-list__products">
                    <order-success-item v-for="(item, indx) in ordered_items"
                    :key="item.ID"
                    :index="indx"
                    :ordered_product="item">
                    </order-success-item>
                </tbody>
                <tbody class="order-list__subtotals">
                    <tr>
                        <th class="order-list__column-label" colspan="3">Subtotal</th>
                        <td class="order-list__column-total notranslate">{{toUSD(ordered_summary.subtotal)}}</td>
                    </tr>
                    <tr v-if="ordered_summary.core_changes > 0">
                        <th class="order-list__column-label" colspan="3">Core Charges</th>
                        <td class="order-list__column-total notranslate">{{toUSD(ordered_summary.core_changes)}}</td>
                    </tr>
                    <tr v-if="ordered_summary.discounttotal > 0">
                        <th class="order-list__column-label" colspan="3">Promotional Discount</th>
                        <td class="order-list__column-total notranslate">- {{toUSD(ordered_summary.discounttotal)}}</td>
                    </tr>
                    <tr v-if="ordered_summary.tax > 0">
                        <th class="order-list__column-label" colspan="3">Tax</th>
                        <td class="order-list__column-total notranslate">{{toUSD(ordered_summary.tax)}}</td>
                    </tr>
                    <tr v-if="ordered_summary.shipping > 0">
                        <th class="order-list__column-label" colspan="3">Shipping</th>
                        <td class="order-list__column-total notranslate">{{toUSD(ordered_summary.shipping)}}</td>
                    </tr>
                </tbody>
                <tfoot class="order-list__footer">
                    <tr>
                        <th class="order-list__column-label" colspan="3">Total</th>
                        <td class="order-list__column-total notranslate">{{toUSD(ordered_summary.grandtotal)}}</td>
                    </tr>
                    <tr v-if="payment_type == 'CC'">
                        <th class="order-list__column-label" colspan="2">Payment Method:</th>
                        <td class="order-list__column-total" colspan="2">Credit Card</td>
                    </tr>
                    <tr v-if="purchaseorder != ''">
                        <th class="order-list__column-label" colspan="2">Purchase Order:</th>
                        <td class="order-list__column-total" colspan="2">{{purchaseorder}}</td>
                    </tr>
                    <tr>
                        <th class="order-list__column-label" colspan="3">Order Notes:<br>
                            <div class="order-list__footer-order-notes">{{ordered_summary.order_notes}}</div>
                        </th> 
                        <td></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>

</template>

<script>
import OrderSuccessItem from './OrderSuccessItem.vue';
import Price from '../../../mixins/price.js';

export default {
    data() {
        return {
            // payment_type : null
        };
    },
    components: {
        OrderSuccessItem
    },
    mixins: [
        Price
    ],
    props: {
        ordered_items: {
            type: Array
        },
        ordered_summary: {
            type: Object
        }
    },
    computed: {
        payment_type() {
            return this.$store.getters['cart/paymenttype'];
        },
        purchaseorder() {
            return this.$store.getters['cart/purchaseorder'];
        }
    },
    created() {

    },
    mounted() {
        console.log(this.ordered_summary);
    },
    unmounted() {
        
    }
}
</script>